var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-btn",
        {
          attrs: {
            color: "indigo",
            dark: "",
            block: "",
            title: "Historial de notificaciones"
          },
          on: {
            click: function($event) {
              return _vm.abrirCerrarDialog()
            }
          }
        },
        [
          _c("v-icon", [_vm._v("today")]),
          _vm._v("\n    Historial notificaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "1400",
            persistent: "",
            transition: "dialog-bottom-transition",
            fullscreen: _vm.fullscreen
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pb-2" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs9: "" } },
                        [
                          _c("v-icon", [_vm._v("today")]),
                          _vm._v("HISTORIAL NOTIFICACIONES")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return function() {
                                _vm.fullscreen = !_vm.fullscreen
                              }.apply(null, arguments)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("fullscreen")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.abrirCerrarDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "px-3 pb-4 mb-2" },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "align-space-between": "",
                            "fill-height": ""
                          }
                        },
                        [
                          _c("v-flex", { attrs: { xs12: "", md8: "" } }, [
                            _c("div", { staticClass: "calendar-container" }, [
                              _c("div", { staticClass: "calendar" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "head-calendar layout row wrap align-center justify-space-between"
                                  },
                                  [
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "icon",
                                          on: { click: _vm.prevMonth }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        chevron_left\n                      "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: {
                                              tag: "div",
                                              name: _vm.typeTransition
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                key: _vm.month,
                                                staticClass: "month-name"
                                              },
                                              [_vm._v(_vm._s(_vm.month))]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { on: { click: _vm.nextMonth } },
                                      [
                                        _c("div", { staticClass: "icon" }, [
                                          _vm._v("chevron_right")
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "days layout row wrap align-center justify-space-between"
                                  },
                                  _vm._l(_vm.dayNames, function(day, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "h-" + index,
                                        staticClass: "col col-center"
                                      },
                                      [
                                        _c("div", { staticClass: "day-name" }, [
                                          _vm._v(_vm._s(day))
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.rows.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "body" },
                                      _vm._l(_vm.rows, function(row, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "r-" + index,
                                            staticClass: "layout row wrap"
                                          },
                                          _vm._l(row.days, function(
                                            day,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: "d-" + index,
                                                staticClass: "col cell",
                                                class: [
                                                  {
                                                    "has-events": day.hasEvents
                                                  },
                                                  day.type
                                                ],
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateDate(day)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "transition-group",
                                                  {
                                                    attrs: {
                                                      tag: "div",
                                                      name: _vm.typeTransition
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        key: day.formattedDate,
                                                        staticClass:
                                                          "day-number-month"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              day.formattedDate
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "transition",
                            {
                              attrs: {
                                tag: "div",
                                name: !_vm.item_selected ? "slide-right" : ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.item_selected,
                                      expression: "!item_selected"
                                    }
                                  ],
                                  attrs: { xs12: "", md4: "" }
                                },
                                [
                                  _c("div", { staticClass: "single-date" }, [
                                    _c("div", { staticClass: "head-date" }, [
                                      _c("div", { staticClass: "day-number" }, [
                                        _vm._v(_vm._s(_vm.selectedDay.number))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "day-name" }, [
                                        _vm._v(_vm._s(_vm.selectedDay.name))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "event-container" },
                                      [
                                        _c("v-treeview", {
                                          staticClass: "tree-content",
                                          attrs: {
                                            open: _vm.open,
                                            items: _vm.dayEvents,
                                            "item-key": "name",
                                            "open-on-click": "",
                                            dark: ""
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "prepend",
                                              fn: function(ref) {
                                                var item = ref.item
                                                var active = ref.active
                                                return [
                                                  item.contador
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "icono-contador",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.seleccionaItem(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "badge"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.contador
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: active
                                                                  ? "primary"
                                                                  : ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            mail\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: active
                                                              ? "primary"
                                                              : ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                item.nivel == 1
                                                                  ? "today"
                                                                  : item.nivel ==
                                                                    2
                                                                  ? "person"
                                                                  : "mail"
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              }
                                            },
                                            {
                                              key: "label",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.name))
                                                  ]),
                                                  _vm._v(" "),
                                                  item.nombre_unidad
                                                    ? _c("div")
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.nro_tarea
                                                    ? _c("div")
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.tree,
                                            callback: function($$v) {
                                              _vm.tree = $$v
                                            },
                                            expression: "tree"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.dayEvents.length == 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "text-xs-center pt-3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    No existe registros\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.dayEvents.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "footer" },
                                          [
                                            _c(
                                              "v-tooltip",
                                              { attrs: { bottom: "" } },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      slot: "activator",
                                                      outline: "",
                                                      icon: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.crearExcel()
                                                      }
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-symbols-outlined"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          table_view\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v("Exportar Excel")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            {
                              attrs: {
                                tag: "div",
                                name: _vm.item_selected ? "slide-right" : ""
                              }
                            },
                            [
                              _vm.item_selected
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md4: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "detalle-notificacion" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      return function() {
                                                        _vm.item_selected = false
                                                      }.apply(null, arguments)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("arrow_back")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "head-date" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "day-number" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.selectedDay.number
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "day-name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.selectedDay.name)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.item_selected
                                                      .l_mensajes[0].nombres
                                                  )
                                                )
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        _vm.item_selected
                                                          .l_mensajes[0]
                                                          .fecha_inicio
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                    "\n                      -\n                      " +
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          _vm.item_selected
                                                            .l_mensajes[0]
                                                            .fecha_fin
                                                        )
                                                        .format("DD/MM/YYYY")
                                                    )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.item_selected.l_mensajes,
                                            function(mensaje, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "mensaje"
                                                },
                                                [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        mensaje.mensaje
                                                          .replace(
                                                            /<br>\s*/g,
                                                            ""
                                                          )
                                                          .replace(
                                                            /<p>\s*/g,
                                                            "<span>"
                                                          )
                                                          .replace(
                                                            /<\/p>\s*/g,
                                                            "</span>"
                                                          )
                                                          .replace(
                                                            /<h1>\s*/g,
                                                            "<h2>"
                                                          )
                                                          .replace(
                                                            /<\/h1>\s*/g,
                                                            "</h2>"
                                                          )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-xs-right indigo--text font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            mensaje.nombre_usuario
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36df1369", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36df1369","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/components/CalendarioNotificaciones.vue
// module id = null
// module chunks = 